export default "__VITE_ASSET__BcCOuwmw__"